<template>
  <Head title="Change Password" />
  <div class="flex min-h-screen items-center justify-center bg-brand-600 p-6">
    <div class="w-full max-w-md">
      <div class="mb-6 flex items-center gap-3">
        <span class="flex h-10 w-10 items-center justify-center rounded-xl bg-white/10 ring-1 ring-white/20">
          <img alt="KTA CMS" src="/images/logo-only.png" class="h-5 w-5" />
        </span>
        <div>
          <p class="text-[11px] font-semibold uppercase tracking-[0.16em] text-white/60">OK Bank</p>
          <p class="text-sm font-bold text-white">KTA CMS</p>
        </div>
      </div>

      <form class="overflow-hidden rounded-2xl bg-white shadow-xl" @submit.prevent="submit">
        <div class="px-8 py-8">
          <p class="text-xs font-semibold uppercase tracking-[0.14em] text-brand-500">Security</p>
          <h1 class="mt-1 text-2xl font-bold tracking-tight text-brand-900">Change password</h1>
          <p class="mt-2 text-sm text-gray-500">
            <template v-if="forced">
              Your account is still using the default password.
              Please set a new password before continuing.
            </template>
            <template v-else>
              Update your account password for
              <span class="font-semibold text-brand-800">{{ user.email }}</span>.
            </template>
          </p>

          <div
            v-if="forced"
            class="mt-5 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800"
          >
            For security, you must change the default password
            <span class="font-semibold">password</span> before using the CMS.
          </div>

          <text-input
            v-model="form.current_password"
            :error="form.errors.current_password"
            class="mt-6"
            label="Current password"
            type="password"
            autocomplete="current-password"
            autofocus
          />
          <text-input
            v-model="form.password"
            :error="form.errors.password"
            class="mt-5"
            label="New password"
            type="password"
            autocomplete="new-password"
          />
          <text-input
            v-model="form.password_confirmation"
            :error="form.errors.password_confirmation"
            class="mt-5"
            label="Confirm new password"
            type="password"
            autocomplete="new-password"
          />
          <p class="mt-3 text-xs text-gray-500">
            Use at least 8 characters. Do not reuse the default password.
          </p>
        </div>

        <div class="flex items-center justify-between gap-3 border-t border-gray-100 bg-gray-50 px-8 py-4">
          <Link
            href="/logout"
            method="delete"
            as="button"
            class="text-sm font-semibold text-gray-500 hover:text-brand-700"
          >
            Logout
          </Link>
          <loading-button
            :loading="form.processing"
            class="inline-flex items-center justify-center rounded-xl bg-brand-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-brand-700"
            type="submit"
          >
            Save new password
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
  },
  layout: null,
  props: {
    forced: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: this.$inertia.form({
        current_password: '',
        password: '',
        password_confirmation: '',
      }),
    }
  },
  methods: {
    submit() {
      this.form.put('/password')
    },
  },
}
</script>
